import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import i18n from "i18next";
import { ListWrapper, ListSection, List, ListTitle, ListItem, ListItemHighlight } from "../list/index";

interface Props extends WithTranslation {
  option_sets: OrderDish["option_sets"];
  renderDetails: RestaurantPrinter["receipt"]["dishes"];
}

interface Injected extends Props {}

class DishOptionSetListClass extends React.Component<Props> {
  render() {
    const { option_sets, renderDetails, t } = this.props as Injected;
    return (
      <ListWrapper>
        {option_sets.map((os, i) => {

          const freeQty = os.conditions.free_amount || 0;

          const totalQuantity = os.options.reduce((tq, o) => tq + o.quantity, 0);

          if (totalQuantity === 0) return null;

          return (
            <ListSection key={i}>
              <ListTitle>{os.display_name || os.name}</ListTitle>
              <List>
                {os.options.map((o, k) => {

                  if (o.quantity === 0)
                    return null;

                  if (renderDetails.option_prices) {

                    if (o.quantity === 1) {
                      return (
                        <ListItem key={k} className="r-list-item">
                          {o.name}{(o.price && !freeQty) ? <ListItemHighlight className="list-item-highlight">+{t("currency", { value: o.price })}</ListItemHighlight> : ""}
                        </ListItem>
                      );
                    }

                    return (
                      <ListItem key={k} className="r-list-item">
                        {o.name}{(o.price && !freeQty) ? (
                        <ListItemHighlight className="list-item-highlight">+{t("currency", { value: o.price })} x {o.quantity}</ListItemHighlight>
                      ) : (
                        <ListItemHighlight className="list-item-highlight"> x {o.quantity}</ListItemHighlight>
                      )}
                      </ListItem>
                    );

                  }

                  if (o.quantity === 1) {
                    return <ListItem key={k} className="r-list-item">{o.name}</ListItem>;
                  }

                  return (
                    <ListItem key={k} className="r-list-item">
                      {o.name} <ListItemHighlight className="list-item-highlight"> x {o.quantity}</ListItemHighlight>
                    </ListItem>
                  );

                })}
              </List>
            </ListSection>
          );

        })}
      </ListWrapper>
    );
  }
}

export const DishOptionSetList = withTranslation()(DishOptionSetListClass);
